import {makeAutoObservable} from 'mobx';

import {ShowcaseItem} from '@/domain/models/Showcase';
import {Subscription} from '@/domain/models/Subscription';
import {ONE_DAY_MS} from '@/shared/consts/time';

const defaultSubscription: Subscription = {
  type: 'none',
  undo_info: null,
};

class SubscriptionStore {
  private instance = defaultSubscription;

  constructor() {
    makeAutoObservable(this);
  }

  get subscription() {
    return this.instance;
  }

  get plusSubscription() {
    return this.instance.type === 'plus';
  }

  setSubscription(subscription: Subscription) {
    this.instance = subscription;
  }

  boughtSubscription(showcaseItem: ShowcaseItem) {
    this.instance = {
      ...this.instance,
      type: 'plus',
      last_duration_unit: showcaseItem.unit_id,
      last_duration_value: showcaseItem.count,
      last_price: showcaseItem.total,
      last_currency: showcaseItem.currency,
      last_status: 'active',
      until: (this.instance.until || Date.now()) + ONE_DAY_MS,
    };
  }
}

export const subscriptionStore = new SubscriptionStore();
